/*-----------------------------
  Page quick-order
  Au click sur "Passer commande", on redirige vers /cart
-----------------------------*/
(() => {
  setTimeout(()=>{$("#checkout").css({"pointerEvents": "auto", "opacity": "1"})},6000)
  const isQOPage = window.location.pathname === '/apps/customer-portal/quick-order';
  if(isQOPage) {
    const loop = setInterval(() => {
      if(document.querySelector("#bss-bcp-qo-checkout-btn")) {
        handleCheckoutQO();
        clearInterval(loop);
      }
    }, 100)
    setTimeout(() => {
      clearInterval(loop);
    }, 10000)
  }

  function handleCheckoutQO(){
    console.log( 'handleCheckoutQO' );
    const btnCheckout = document.querySelector("#bss-bcp-qo-checkout-btn");
          btnCheckout.setAttribute('aria-disabled', 'false');
          btnCheckout.classList.remove('Polaris-Button--disabled');
    
    btnCheckout.addEventListener("click", function(event) {
      event.preventDefault();
      event.stopPropagation(); // Prevents the event from bubbling up to the outer button

      // Redirect to the /cart page
      window.location.href = '/cart';
      
    }, true);
  }
})();

    setTimeout(() => {
        function handleButtonClick(e) {
            e.preventDefault();
            const $button = $(this);
            let oldText = $(this).text();
            $button.css({'pointer-events': 'none', 'opacity': '0.6'});
            $button.text("Loading ...");
            setTimeout(() => {
                $button.css({'pointer-events': 'unset', 'opacity': '1'})
                $button.text(oldText);
            }, 2000);
        }
        $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
    }, 500)
    BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
        window.location.href = "/checkout";
    }

// BSS original code
/*(() => {
  const isQOPage = window.location.pathname === '/apps/customer-portal/quick-order';
  if(isQOPage) {
    const loop = setInterval(() => {
      if(document.querySelector("#bss-bcp-qo-checkout-btn.Polaris-Button--disabled")) {
        handleCheckoutQO();
        clearInterval(loop);
      }
    }, 100)
    setTimeout(() => {
      clearInterval(loop);
    }, 10000)
  }

  function handleCheckoutQO(){
    document.addEventListener("click", function(e) {
      const target = e.target;
      if(!target.classList.contains("Polaris-ButtonGroup__Item")) return;
      const closestButton = target.querySelector("#bss-bcp-qo-checkout-btn.Polaris-Button--disabled");
      if (closestButton) {
          const textButton = closestButton.querySelector(".Polaris-Button__Content")
          textButton && textButton.insertAdjacentHTML("afterbegin", `<span class="Polaris-Button__Spinner"><span class="Polaris-Spinner Polaris-Spinner--sizeSmall"><svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.229 1.173a9.25 9.25 0 1011.655 11.412 1.25 1.25 0 10-2.4-.698 6.75 6.75 0 11-8.506-8.329 1.25 1.25 0 10-.75-2.385z"></path></svg></span><span role="status"><span class="Polaris-Text--root Polaris-Text--visuallyHidden"></span></span></span>`)
          let btnCheckout = document.querySelector('.cart-container .add_to_cart');
          if(btnCheckout) btnCheckout.click();
      }
    }, true);
  }
})();*/


/*******************************************
* BSS Quick Order
*******************************************/
/*(() => {
  const isQOPage = window.location.pathname === '/apps/customer-portal/quick-order';
  if(isQOPage) {
    const btnAddCart = document.querySelector('.add_to_cart_line_item button');

    document.addEventListener("click", function(e) {
      const target = e.target;
      console.log( target );

      let parentElement = target.closest('li');
      if (parentElement) {
        parentElement.classList.add('new-class');

        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success(cart) {
            setTimeout(function () {
              //console.log( cart ); // STEPH
              //refreshCart(cart);
            }, 500);
          }
        });
      }
    }, true);
  }
})();*/

if (BSS_B2B) {
  document.addEventListener("bss_b2b_cart_fixer_done", ()=>{
    $("#checkout").css({"pointerEvents": "auto", "opacity": "1"})
  })
 
}

document.addEventListener("DOMContentLoaded", function() {
   if (window.location.pathname.includes("apps/customer-portal")) {
        var style = document.createElement('style');
        style.innerHTML = `
          .bss-b2b-qo-vat-price-no-vat,
          .bss-b2b-qo-vat-price-has-vat,
          .bss-bcp-qo-product-list-table .price-field > p {
              display: flex;
          }
          .bss-bcp-qo-product-list-table .price-field > p {
              gap: 4px;
          }
          .bss-bcp-qo-cart-table .line-item-total-price > p {
              display: flex;
              flex-direction: column;
          }
        `;
    document.head.appendChild(style);
   }
});
 setTimeout(()=>{
    if (window.location.pathname.includes("/product")) {
      if (BSS_B2B) {
         BSS_B2B.ef.getAppliedRuleOnProductPage(false)
      }
    }
  },2000)